<div class="z-10 w-full flex justify-center mt-4" [style.marginBottom]="mobile ? '2.5rem' : '6rem'"  id="plan-container">

  <!--   Hidden form for form post to BankServ   -->
  <ng-container *ngIf="initiateResponseCard">
    <form [action]="initiateResponseCard.acsUrl" method="post" id="acs-form" class="cdk-visually-hidden" hidden>
      <input name="MD" [value]="initiateResponseCard.acsMD" id="MD" hidden>
      <input name="PaReq" [value]="initiateResponseCard.acsPayload" id="PaReq" hidden>
      <input name="TermUrl" [value]="initiateResponseCard.acsTermUrl" id="TermUrl" hidden>
    </form>
  </ng-container>
  <div class="z-10 w-full flex justify-center mt-4" [style.marginBottom]="mobile ? '2.5rem' : '6rem'"  id="plan-container">
    <div class="background-image background-cover z-50 text-center w-full flex justify-center">

      <div class="flex flex-col w-9/12 justify-center">
        <div class="h-9/12">
          <div class="w-full">
            <div class="flex flex-row justify-end items-end pb-3 h-10 w-full">
              <img src="../../assets/vis/VisaInstallmentsSymbol.svg" style="horiz-align: right; height: 100%;">
            </div>
          </div>
          <div class="flex flex-row justify-between w-full">
            <p>Total Amount</p>
            <p>{{ selected.costInfo.currency + " " + (selected.costInfo.totalPlanCost / 100).toFixed(2) }}</p>
          </div>
          <div class="flex flex-row justify-between w-full">
            <p>Total Fees</p>
            <p>{{ selected.costInfo.currency + " " + (selected.costInfo.totalFees / 100).toFixed(2)}}</p>
          </div>
          <div class="flex flex-row justify-between w-full">
            <p>Annual Percentage Rate @ {{selected.costInfo.annualPercentageRate}}%</p>
          </div>
          <div class="flex flex-row justify-between w-full">
            <p>Monthly Payment</p>
            <p>{{ selected.costInfo.currency + " " + ((selected.costInfo.firstInstallment.amount + selected.costInfo.firstInstallment.installmentFee) / 100).toFixed(2) + (
            !(selected.installmentFrequency == 'One Time Payment') ? ('/' + selected.installmentFrequency.toLowerCase() + ' x ' + selected.numberOfInstallments) : '')}}</p>
          </div>
        </div>
        <div class="flex items-center mr-4 ml-6 pt-3 pb-3 h-1/12">
          <hr class="border-t border-gray-300 flex-grow mr-4">
          <img src="../../assets/vis/Logo/1line/blue/IEBVlockup_1line_blu_UK_012922.svg" style="height: 39%; ">
          <hr class="border-t border-gray-300 flex-grow ml-4">
        </div>
        <div *ngIf="terms" (click)="toggleExpanded()" class="background-image background-cover z-50 text-center w-full overflow-y-auto overflow-x-hidden h-2/12">
          <h1 class="w-full text-sm font-bold">
            Terms & Conditions
          </h1>

          <p class="justify-center text-xs">
            {{ isExpanded ? terms : (terms | slice:0:50) }}
            {{ isExpanded ? '' : ' ...' }}
          </p>
          <p class="justify-center text-xs">
            For questions regarding your installment plan, please contact your bank.
          </p>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="w-full flex flex-col justify-center absolute" [ngStyle]="{'bottom': '15%'}" >
  <div>

    <div class="flex justify-center" [ngClass]="mobile ? 'flex-col' : 'flex-row-reverse'">
      <div class="flex justify-center items-center flex-col confirm-container mt-2" [ngClass]="mobile ? 'mb-2' : 'mb-4'" *ngIf="!paymentConfirm">
        <button [disabled]="loading || selected === undefined || selected === null"
                class="text-xl text-white font-medium border-solid rounded-lg continue-button pt-2 pb-2 max-w-225 wpx-225 flex justify-center"
                [ngStyle]="{'background-color': headerColor}"
                (click)="initiateRequestCardFn()">
          <span *ngIf="!loading">{{ 'OK' }} </span>
          <mat-spinner
            *ngIf="loading"
            class="loading-spinner mb-1 mt-1"
            [color]="color"
            [diameter]="diameterContinue"
          >
          </mat-spinner>
        </button>
      </div>
      <div class="flex justify-center items-center flex-col confirm-container mt-2 mb-4" [ngClass]="mobile ? 'mr-0' : 'mr-4'" *ngIf="!paymentConfirm">
        <button [disabled]="loading" class="text-xl font-medium rounded-lg continue-button px-16 flex items-center"
                [ngStyle]="{'height': '48px', 'color': 'black',  'border': '3px solid ' + headerColor }" mat-button
                (click)="back()">
          <p class="p-0 m-0" *ngIf="!transactionCancelled">{{ 'BACK' }}</p>
          <mat-spinner
            *ngIf="transactionCancelled"
            class="loading-spinner mb-4 mt-4"
            [color]="color"
            [diameter]="diameterColour"
          >
          </mat-spinner>
        </button>
      </div>
    </div>
  </div>
  <div class="w-100 flex justify-center text-center px-4 mat-typography" style="padding-bottom: 5px;">
    <span class="text-xs">You may be redirected to your bank’s secure site to authenticate yourself before making the payment.</span>
  </div>
</div>

